<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>编辑门店费用</el-breadcrumb-item>
    </el-breadcrumb>

    <el-date-picker
      v-model="costRequest.costDate"
      type="month"
      size="mini"
      placeholder="选择修改月份"
      value-format="yyyy-MM"
    >
    </el-date-picker>
    <el-select v-model="costRequest.costId" clearable value filterable placeholder="请选择补助类目"
               style="width: 200px" size="mini" @change="getSelectCostMethod">
      <el-option
        v-for="orgCost in orgCostList"
        :key="orgCost.costId"
        :label="orgCost.costCnName"
        :value="orgCost.costId">
      </el-option>
    </el-select>
    <el-select v-model="selectOrgId" v-if="orgLevel < 3 " clearable value filterable placeholder="请选择门店"
               style="width: 200px" size="mini" @change="getShop">
      <el-option
        v-for="org in shop"
        :key="org.id"
        :label="org.orgName"
        :value="org.id">
      </el-option>
    </el-select>
    <el-button size="mini" style="width: 15%" @click="loadUserCost">查询</el-button>


    <el-table height="600px" :data="userCostList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :row-style="{height: '0'}" >
      <el-table-column
        align="center"
        fixed="fixed"
        label="操作" width="100"
      >
        <template slot-scope="scope">
          <el-link type="primary" v-if="authorities.includes('finance.yuangongbuzhu.delete')" icon="el-icon-delete"
                   @click="deleteUserCost(scope.$index, userCostList, scope.row)"></el-link>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="costDate"
        label="月份">
      </el-table-column>
      <el-table-column
        align="center"
        prop="costCnName"
        label="补助类目">
      </el-table-column>
      <el-table-column
        align="center"
        label="金额">
        <template slot-scope="scope">
          <el-input v-model="scope.row.money" size="mini"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="orgName"
        label="门店名称">
      </el-table-column>
      <el-table-column
        align="center"
        label="备注">
        <template slot-scope="scope">
          <el-input v-model="scope.row.comment" size="mini"></el-input>
        </template>
      </el-table-column>
    </el-table>
    <span class="dialog-footer">
      <el-button size="mini" @click="closeUserSubsidyDialog">返 回</el-button>
      <el-button size="mini" @click="createUserSubsidy">确 定</el-button>
    </span>
  </div>

</template>

<script>
export default {
  data() {
    return {
      orgId:'',
      userId:'',
      userName:'',
      costRequest:{
        costType:3,
        costDate:'',
        costId:'',
        orgId:'',
        areaId:''
      },
      orgCostList:[],
      userCostList:[],
      userCost:{
        creator:'',
        createName:'',
        subsidyList:[],
        deletedCosts:[],
      },
      selectOrgId:'',
      shop:[],
      orgLevel:'',
      deletedCosts:[]
    }
  },
  methods:{
    async loadOrgCost(){
      const {data:res} = await this.$http.get(`/cost/orgId/${this.orgId}/costType/${3}`);
      this.orgCostList = res.data;
    },
    getSelectCostMethod(data){
      this.costRequest.costId = data;
    },
    async loadUserCost(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post('/copy/cost/shopCosts', this.costRequest);
      this.userCostList = res.data;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
    },
    //获取系统当前日期
    getCurrentDate() {
      let date = new Date(new Date().getTime());
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? '0' + month : month
      return year + '-' + month;
    },
    closeUserSubsidyDialog(){
      this.$router.go(-1);
    },
    async createUserSubsidy(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      this.userCost.subsidyList = this.userCostList;
      this.userCost.creator = this.userId;
      this.userCost.createName = this.userName;
      this.userCost.deletedCosts = this.deletedCosts;
      const {data:res} = await this.$http.post(`/save/edit/cost`, this.userCost);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.closeUserSubsidyDialog();
    },
    deleteUserCost(index,rows, row){
      rows.splice(index, 1);
      this.deletedCosts.push(row);
    },
    async getShop(data){
      if (data !== ''){
        this.costRequest.orgId = data;
        // const {data:res} = await this.$http.get(`/org/users/${data}`);
        // this.users = res.data;
      } else {
        this.costRequest.orgId = '';
      }
    },
    async loadShop(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      this.shop = res.data;
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.userName = window.sessionStorage.getItem("userName");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    if(this.orgLevel == 2){
      this.costRequest.areaId = this.orgId;
    }
    this.loadOrgCost();
    this.loadShop();
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
}
.left_con{
  height: 100%;
  overflow-y: auto;
  flex: 1;
  margin: 10px 0;
  /*border: 1px solid;*/
}
.table_container{
  width: 80%;
  flex: 4;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.outside_con{
  height: 250px;
}
.dialog-footer{
  display: flex;
  margin-top: 10px;
  //margin: 10px 10px;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/EditShopCost.vue